import pseudoPrefixer from 'fela-plugin-pseudo-prefixer';

var placeholderPrefixes = ['::-webkit-input-placeholder', '::-moz-placeholder', ':-ms-input-placeholder', ':-moz-placeholder', '::placeholder'];

export default function placeholderPrefixer() {
  return pseudoPrefixer('::placeholder', placeholderPrefixes);
}